// This file was auto-generated by Fern from our API Definition.
export var SimpleApplicationDataInput;
(function (SimpleApplicationDataInput) {
    SimpleApplicationDataInput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(SimpleApplicationDataInput || (SimpleApplicationDataInput = {}));
